<template>
    <a-drawer
      placement="left"
      :closable="false"
      :visible="visible"
      @close="onClose"
    >
        <div class="drawer-left">
            <LeftMenu isDrawer @drawerChange='onClose'></LeftMenu>
        </div>
    </a-drawer>
</template>

<script>
import LeftMenu from './LeftMenu.vue'
export default {
    props:{
        visible:{
            type: Boolean,
            default: false
        }
    },
    watch:{
      '$route':{
        handler(to,from) {
          this.fullPath = from.fullPath
          sessionStorage.setItem('weidun_fullPath',from.fullPath)
        }
      }
    },
    components:{
        LeftMenu
    },
    methods: {
        onClose() {
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-drawer-body{
    padding: 0 !important;
}
.drawer-left{
    height: 100vh;
}
</style>